export default (state, indexes, row) => {
  let { currentEditMessage, currentEditSlidePage } = state
  const { message_index, row_index, row_index_detail } = indexes
  // false : normal (currentEditMessage)
  // true : depth component 
  const editFlag = row_index_detail || row_index_detail === 0
  let editTarget = editFlag ? [currentEditSlidePage] : currentEditMessage
  const editState = editFlag ? 'SLIDE_PAGE' : 'MESSAGE'
  
  // depthComponent를 수정할 시엔 message_index는 0으로 지정함
  const message_index_calc = editFlag ? 0 : message_index
  const row_index_calc = editFlag ? row_index_detail-1 : row_index-1 
  if (editTarget) {
    editTarget = editTarget.map((element, i) => {
      if (message_index_calc === i) {
        let { rows } = element
        
        rows = rows.map((_row, i) => {
          if (i === row_index_calc) {
            return {
              ..._row,
              ...row,
            }
          }
          return _row
        })
        return {
          ...element,
          rows: rows,
        }
      }
      return element
    })
  } else { console.error('editTarget이 존재하지 않음 -> ', editTarget) }

  if (editFlag) {
    return {
      editState: editState,
      result: editTarget[0],
    }
  }

  return {
    editState: editState,
    result: editTarget,
  }
}